export default [
  'UserService', 'UserDataService', 'StateTerritoryData', 'ErrorHandler',
  class DefaultAddressCtrl {
    constructor(userService, userData, states, errorHandler) {
      this._userService = userService;
      this._errors = errorHandler;

      this.currentUser = {};
      this.loading = true;
      this.address = {};
      this.edit = false;
      this.noAddress = true;
      this.thankYou = false;
      this.originalZip = '00000';

      this.countries = states.getCountries();
      this.states = states.getExtendedStates();
      this.provinces = states.getProvinces();

      userData.getUserData()
        .then((customer) => {
          this.currentUser = customer.user;
          if (customer.user.user_info.shipping_details.street_1) {
            this.address = customer.user.user_info.shipping_details;
            this.noAddress = false;
            this.originalZip = this.address.zip;
          } else {
            this.address.country = 'US';
          }
        })
        .catch(() => this._errors.throwError('Data Error', 'Unable to retrieve your saved address. Please try again in a few minutes.'))
        .finally(() => this.loading = false);
    }

    submit(valid) {
      if (valid) {
        this.loading = true;
        this._userService.updateAddress(
            this.currentUser.user_info.public_name, this.address.name, this.address.street_1,
            this.address.city, this.address.state, this.address.zip,
            this.address.country, this.address.mobile, this.address.street_2
          )
          .then(() => {
            this.thankYou = true;
            this.noAddress = false;
            this.edit = false;
          })
          .catch(() => this._errors.throwError('Save Address Error', 'We were unable to save your new address. Please try again in a few minutes.'))
          .finally(() => this.loading = false);
      }
    }

    countryChanged() {
      this.address.zip = '';
      this.address.state = '';
    }
  }
];



// WEBPACK FOOTER //
// ./source/client/pages/my-account/default-address.ctrl.js